<template>
    <span class="status">
        <i class="fa fa-circle-o fa-2x fa-fw" :class="'status-'+object.status+'c'" v-if="object.status == 0" :title="$t('device.registrations.cols.state.0')"></i>
        <i class="fa fa-clock-o fa-2x fa-fw" :class="'status-'+object.status+'c'" v-if="object.status == 1" :title="$t('device.registrations.cols.state.1')"></i>
        <span class="fa-stack fa-fw" v-if="object.status == 2" :title="$t('device.registrations.cols.state.2')"><i class="fa fa-circle-o fa-stack-2x"></i><i class="fa fa-mobile-phone fa-stack-1x" :class="'status-'+object.status+'c'" ></i></span>
        <i class="fa fa-times-circle-o fa-2x fa-fw" :class="'status-'+object.status+'c'" v-if="object.status == 3" :title="$t('device.registrations.cols.state.3')"></i>
    </span>
</template>

<script>
    export default {
        name: 'statusrenderer',
        props: ['object'],
        data: () => ({

        })
    }
</script>

<style lang="scss" scoped>

</style>
